<template>
  <!-- name: '关于我们' -->
  <div class="aboutUsWrap">
    <img src="https://img.bbalt.cn/imgh5/other/bg_aboutUS.png" alt="" class="bgClass" />
    <div class="btnListBox">
      <div class="btnClass"  @click="$router.push({ path: '/about', query: { code:'aboutUs' , title: '认识宝贝爱蓝天' } })">
        <img src="https://img.bbalt.cn/imgh5/other/img_about_butterfly.png" alt="" />
        认识宝贝爱蓝天
        <img src="https://img.bbalt.cn/imgh5/other/icon_triangle_left.svg" alt="" />
      </div>
      <div class="btnClass" @click="$router.push({ path: '/about', query: { code:'projectIntroduction' , title: '公益项目介绍' } })">
        <img src="https://img.bbalt.cn/imgh5/other/img_about_project.svg" alt="" />
        公益项目介绍
        <img src="https://img.bbalt.cn/imgh5/other/icon_triangle_left.svg" alt="" />
      </div>
      <div class="btnClass" @click="$router.push({ path: '/about', query: { code:'ourSupporters' , title: '我们的支持者' } })">
        <img src="https://img.bbalt.cn/imgh5/other/img_about_support.svg" alt="" />
        我们的支持者
        <img src="https://img.bbalt.cn/imgh5/other/icon_triangle_left.svg" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {};
  },
  created() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.aboutUsWrap {
  height: 100%;
  width: 100%;
  overflow: hidden;
  padding-bottom: 37px;
  background-color: #fff5dc;
  position: relative;
  .bgClass {
    width: 100%;
    height: 414px;
  }
  .btnListBox {
    position: absolute;
    top: 262px;
    left: 32px;
    .btnClass {
      width: 686px;
      height: 212px;
      background-image: url("https://img.bbalt.cn/imgh5/other/btn_bg_aboutus.svg");
      background-repeat: no-repeat;
      background-size: 100%;
      border-radius: 16px;
      margin-bottom: 12px;
      font-size: 36px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      color: #333333;
      line-height: 46px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      img {
        &:first-child {
          width: 160px;
          height: 160px;
          margin: 0px 30px;
        }
        &:last-child {
          width: 20px;
          height: 20px;
          margin-left: 12px;
        }
      }
    }
  }
}
</style>
